import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'
import { getErrorMessage } from 'utils/get-error-message'

export const ErrorMessage = ({
  errorMessage,
  classNames
}: {
  errorMessage?: string
  classNames?: string
}) => {
  const { t } = useTranslation('errors')
  if (!errorMessage) {
    return null
  }

  return (
    <span
      className={twMerge(
        'mt-1 text-xs font-medium leading-4 text-red-500',
        classNames
      )}
    >
      {getErrorMessage(t, errorMessage)}
    </span>
  )
}
